/**
 * @readonly
 * @enum {string}
 */
const InboxMessage = Object.freeze({
    ID: 'id',
    TITLE: 'title',
    MAINTENANCE_DATE: 'maintenanceDate',
    IS_READ: 'isRead',
    START_DATE: 'startDate',
    END_DATE: 'endDate',
    ATTRIBUTES: 'attributes'
})

export { InboxMessage }
